var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gru-table',{attrs:{"resource_title":'lang.role.role',"resource":'role',"fields":_vm.fields,"enabledExcel":false,"enabledPrint":false,"enabledDelete":true}})}
var staticRenderFns = []

export { render, staticRenderFns }